export const CLIENT_ICP_TYPE_OPTIONS = [
  { value: 'consumer_brand', label: 'DTC / consumer brand' },
  { value: 'funded_startup', label: 'B2B SaaS / tech startup' },
  { value: 'agency', label: 'Agency' },
  { value: 'other', label: 'Other' },
];

export const CLIENT_COMPANY_SIZE_OPTIONS = [
  { value: 'solo', label: 'Solo' },
  { value: '2_10', label: '2–10' },
  { value: '11_50', label: '11–50' },
  { value: '51_200', label: '51–200' },
  { value: '201_plus', label: '201+' },
];

export function getBuyerLoginPath() {
  return '/ats';
}
